import React from "react";
import TablaSucursal from "js/components/TablaSucursalProducto";

export const Sucursal = props => {
  return <TablaSucursal />;
};

export default Sucursal;
